// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.spinner-overlay {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background: linear-gradient(135deg, rgba(66, 133, 244, 0.1) 0%, rgba(52, 168, 83, 0.1) 100%);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: fadeIn 0.3s ease-in-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.spinner-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 40px;
}

.loader {
  position: relative;
  width: 120px;
  height: 120px;
  animation: rotate 2s linear infinite;
}

@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.loader-circle {
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  animation: animate 1.5s linear infinite;
}

.loader-circle:nth-child(1) {
  animation-delay: 0s;
}

.loader-circle:nth-child(2) {
  animation-delay: -0.3s;
}

.loader-circle:nth-child(3) {
  animation-delay: -0.6s;
}

.loader-circle:nth-child(4) {
  animation-delay: -0.9s;
}

.loader-circle:nth-child(5) {
  animation-delay: -1.2s;
}

.loader-circle:nth-child(6) {
  animation-delay: -1.5s;
}

.loader-circle:nth-child(7) {
  animation-delay: -1.8s;
}

.loader-circle:nth-child(8) {
  animation-delay: -2.1s;
}

.loader-circle::before {
  content: '';
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 15px;
  height: 15px;
  background: #4285f4;
  border-radius: 50%;
  box-shadow: 0 0 20px rgba(66, 133, 244, 0.8);
}

.loader-circle:nth-child(2)::before {
  background: #34a853;
  box-shadow: 0 0 20px rgba(52, 168, 83, 0.8);
}

.loader-circle:nth-child(3)::before {
  background: #fbbc05;
  box-shadow: 0 0 20px rgba(251, 188, 5, 0.8);
}

.loader-circle:nth-child(4)::before {
  background: #ea4335;
  box-shadow: 0 0 20px rgba(234, 67, 53, 0.8);
}

.loader-circle:nth-child(5)::before {
  background: #9c27b0;
  box-shadow: 0 0 20px rgba(156, 39, 176, 0.8);
}

.loader-circle:nth-child(6)::before {
  background: #ff5722;
  box-shadow: 0 0 20px rgba(255, 87, 34, 0.8);
}

.loader-circle:nth-child(7)::before {
  background: #00bcd4;
  box-shadow: 0 0 20px rgba(0, 188, 212, 0.8);
}

.loader-circle:nth-child(8)::before {
  background: #ff9800;
  box-shadow: 0 0 20px rgba(255, 152, 0, 0.8);
}

@keyframes animate {
  0% {
    transform: rotate(0deg);
    opacity: 1;
    filter: blur(0px);
  }
  50% {
    transform: rotate(180deg);
    opacity: 0.5;
    filter: blur(2px);
  }
  100% {
    transform: rotate(360deg);
    opacity: 1;
    filter: blur(0px);
  }
}

.loading-text {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  font-size: 24px;
  font-weight: 600;
  color: #333;
  letter-spacing: 2px;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

.loading-text .letter {
  display: inline-block;
  animation: wave 1.5s ease-in-out infinite;
  min-width: 2px;
}

/* Arabic phrase animation */
.loading-text .phrase {
  display: inline-block;
  animation: pulse 1.5s ease-in-out infinite;
  font-family: 'Segoe UI', Tahoma, 'Arial', sans-serif;
  font-size: 26px;
  font-weight: 600;
  letter-spacing: 0;
  white-space: nowrap;
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
    transform: scale(1);
    color: #333;
  }
  50% {
    opacity: 0.7;
    transform: scale(1.05);
    color: #4285f4;
  }
}

@keyframes wave {
  0%, 100% {
    transform: translateY(0);
    color: #333;
  }
  50% {
    transform: translateY(-10px);
    color: #4285f4;
  }
}

@keyframes bounce {
  0%, 80%, 100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-15px);
  }
}

/* RTL Support */
[dir="rtl"] .loading-text {
  letter-spacing: 0;
  font-family: 'Segoe UI', Tahoma, 'Arial', sans-serif;
  font-size: 26px;
}

[dir="rtl"] .loading-text .letter {
  min-width: 1px;
}

[dir="rtl"] .loading-text.arabic-text {
  direction: rtl;
}

.loading-text .dots {
  display: inline-block;
  animation: bounce 1.4s ease-in-out infinite;
}

.loading-text .dots:nth-child(8) {
  animation-delay: 0s;
}

.loading-text .dots:nth-child(9) {
  animation-delay: 0.2s;
}

.loading-text .dots:nth-child(10) {
  animation-delay: 0.4s;
}

/* RTL Support */
[dir="rtl"] .loading-text {
  direction: rtl;
}

/* Responsive Design */
@media (max-width: 768px) {
  .loader {
    width: 100px;
    height: 100px;
  }

  .loader-circle::before {
    width: 12px;
    height: 12px;
  }

  .loading-text {
    font-size: 20px;
  }

  .loading-text .phrase {
    font-size: 22px;
  }

  [dir="rtl"] .loading-text {
    font-size: 22px;
  }
}

@media (prefers-color-scheme: dark) {
  .loading-text {
    color: #fff;
  }

  .loading-text .letter {
    color: #fff;
  }

  .loading-text .phrase {
    color: #fff;
  }

  @keyframes wave {
    0%, 100% {
      transform: translateY(0);
      color: #fff;
    }
    50% {
      transform: translateY(-10px);
      color: #4285f4;
    }
  }

  @keyframes pulse {
    0%, 100% {
      opacity: 1;
      transform: scale(1);
      color: #fff;
    }
    50% {
      opacity: 0.7;
      transform: scale(1.05);
      color: #4285f4;
    }
  }
}
`, "",{"version":3,"sources":["webpack://./src/app/shared/components/spinner/spinner.component.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,OAAO;EACP,MAAM;EACN,4FAA4F;EAC5F,2BAA2B;EAC3B,mCAAmC;EACnC,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kCAAkC;AACpC;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,oCAAoC;AACtC;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE;IACE,uBAAuB;IACvB,UAAU;IACV,iBAAiB;EACnB;EACA;IACE,yBAAyB;IACzB,YAAY;IACZ,iBAAiB;EACnB;EACA;IACE,yBAAyB;IACzB,UAAU;IACV,iBAAiB;EACnB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,4DAA4D;AAC9D;;AAEA;EACE,qBAAqB;EACrB,yCAAyC;EACzC,cAAc;AAChB;;AAEA,4BAA4B;AAC5B;EACE,qBAAqB;EACrB,0CAA0C;EAC1C,oDAAoD;EACpD,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE;IACE,UAAU;IACV,mBAAmB;IACnB,WAAW;EACb;EACA;IACE,YAAY;IACZ,sBAAsB;IACtB,cAAc;EAChB;AACF;;AAEA;EACE;IACE,wBAAwB;IACxB,WAAW;EACb;EACA;IACE,4BAA4B;IAC5B,cAAc;EAChB;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA,gBAAgB;AAChB;EACE,iBAAiB;EACjB,oDAAoD;EACpD,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA,gBAAgB;AAChB;EACE,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE;MACE,wBAAwB;MACxB,WAAW;IACb;IACA;MACE,4BAA4B;MAC5B,cAAc;IAChB;EACF;;EAEA;IACE;MACE,UAAU;MACV,mBAAmB;MACnB,WAAW;IACb;IACA;MACE,YAAY;MACZ,sBAAsB;MACtB,cAAc;IAChB;EACF;AACF","sourcesContent":[".spinner-overlay {\r\n  position: fixed;\r\n  width: 100%;\r\n  height: 100%;\r\n  left: 0;\r\n  top: 0;\r\n  background: linear-gradient(135deg, rgba(66, 133, 244, 0.1) 0%, rgba(52, 168, 83, 0.1) 100%);\r\n  backdrop-filter: blur(10px);\r\n  -webkit-backdrop-filter: blur(10px);\r\n  z-index: 9999;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  animation: fadeIn 0.3s ease-in-out;\r\n}\r\n\r\n@keyframes fadeIn {\r\n  from {\r\n    opacity: 0;\r\n  }\r\n  to {\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n.spinner-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 40px;\r\n}\r\n\r\n.loader {\r\n  position: relative;\r\n  width: 120px;\r\n  height: 120px;\r\n  animation: rotate 2s linear infinite;\r\n}\r\n\r\n@keyframes rotate {\r\n  0% {\r\n    transform: rotate(0deg);\r\n  }\r\n  100% {\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n\r\n.loader-circle {\r\n  position: absolute;\r\n  width: 100%;\r\n  height: 100%;\r\n  border-radius: 50%;\r\n  animation: animate 1.5s linear infinite;\r\n}\r\n\r\n.loader-circle:nth-child(1) {\r\n  animation-delay: 0s;\r\n}\r\n\r\n.loader-circle:nth-child(2) {\r\n  animation-delay: -0.3s;\r\n}\r\n\r\n.loader-circle:nth-child(3) {\r\n  animation-delay: -0.6s;\r\n}\r\n\r\n.loader-circle:nth-child(4) {\r\n  animation-delay: -0.9s;\r\n}\r\n\r\n.loader-circle:nth-child(5) {\r\n  animation-delay: -1.2s;\r\n}\r\n\r\n.loader-circle:nth-child(6) {\r\n  animation-delay: -1.5s;\r\n}\r\n\r\n.loader-circle:nth-child(7) {\r\n  animation-delay: -1.8s;\r\n}\r\n\r\n.loader-circle:nth-child(8) {\r\n  animation-delay: -2.1s;\r\n}\r\n\r\n.loader-circle::before {\r\n  content: '';\r\n  position: absolute;\r\n  top: 0;\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  width: 15px;\r\n  height: 15px;\r\n  background: #4285f4;\r\n  border-radius: 50%;\r\n  box-shadow: 0 0 20px rgba(66, 133, 244, 0.8);\r\n}\r\n\r\n.loader-circle:nth-child(2)::before {\r\n  background: #34a853;\r\n  box-shadow: 0 0 20px rgba(52, 168, 83, 0.8);\r\n}\r\n\r\n.loader-circle:nth-child(3)::before {\r\n  background: #fbbc05;\r\n  box-shadow: 0 0 20px rgba(251, 188, 5, 0.8);\r\n}\r\n\r\n.loader-circle:nth-child(4)::before {\r\n  background: #ea4335;\r\n  box-shadow: 0 0 20px rgba(234, 67, 53, 0.8);\r\n}\r\n\r\n.loader-circle:nth-child(5)::before {\r\n  background: #9c27b0;\r\n  box-shadow: 0 0 20px rgba(156, 39, 176, 0.8);\r\n}\r\n\r\n.loader-circle:nth-child(6)::before {\r\n  background: #ff5722;\r\n  box-shadow: 0 0 20px rgba(255, 87, 34, 0.8);\r\n}\r\n\r\n.loader-circle:nth-child(7)::before {\r\n  background: #00bcd4;\r\n  box-shadow: 0 0 20px rgba(0, 188, 212, 0.8);\r\n}\r\n\r\n.loader-circle:nth-child(8)::before {\r\n  background: #ff9800;\r\n  box-shadow: 0 0 20px rgba(255, 152, 0, 0.8);\r\n}\r\n\r\n@keyframes animate {\r\n  0% {\r\n    transform: rotate(0deg);\r\n    opacity: 1;\r\n    filter: blur(0px);\r\n  }\r\n  50% {\r\n    transform: rotate(180deg);\r\n    opacity: 0.5;\r\n    filter: blur(2px);\r\n  }\r\n  100% {\r\n    transform: rotate(360deg);\r\n    opacity: 1;\r\n    filter: blur(0px);\r\n  }\r\n}\r\n\r\n.loading-text {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 4px;\r\n  font-size: 24px;\r\n  font-weight: 600;\r\n  color: #333;\r\n  letter-spacing: 2px;\r\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n}\r\n\r\n.loading-text .letter {\r\n  display: inline-block;\r\n  animation: wave 1.5s ease-in-out infinite;\r\n  min-width: 2px;\r\n}\r\n\r\n/* Arabic phrase animation */\r\n.loading-text .phrase {\r\n  display: inline-block;\r\n  animation: pulse 1.5s ease-in-out infinite;\r\n  font-family: 'Segoe UI', Tahoma, 'Arial', sans-serif;\r\n  font-size: 26px;\r\n  font-weight: 600;\r\n  letter-spacing: 0;\r\n  white-space: nowrap;\r\n}\r\n\r\n@keyframes pulse {\r\n  0%, 100% {\r\n    opacity: 1;\r\n    transform: scale(1);\r\n    color: #333;\r\n  }\r\n  50% {\r\n    opacity: 0.7;\r\n    transform: scale(1.05);\r\n    color: #4285f4;\r\n  }\r\n}\r\n\r\n@keyframes wave {\r\n  0%, 100% {\r\n    transform: translateY(0);\r\n    color: #333;\r\n  }\r\n  50% {\r\n    transform: translateY(-10px);\r\n    color: #4285f4;\r\n  }\r\n}\r\n\r\n@keyframes bounce {\r\n  0%, 80%, 100% {\r\n    transform: translateY(0);\r\n  }\r\n  40% {\r\n    transform: translateY(-15px);\r\n  }\r\n}\r\n\r\n/* RTL Support */\r\n[dir=\"rtl\"] .loading-text {\r\n  letter-spacing: 0;\r\n  font-family: 'Segoe UI', Tahoma, 'Arial', sans-serif;\r\n  font-size: 26px;\r\n}\r\n\r\n[dir=\"rtl\"] .loading-text .letter {\r\n  min-width: 1px;\r\n}\r\n\r\n[dir=\"rtl\"] .loading-text.arabic-text {\r\n  direction: rtl;\r\n}\r\n\r\n.loading-text .dots {\r\n  display: inline-block;\r\n  animation: bounce 1.4s ease-in-out infinite;\r\n}\r\n\r\n.loading-text .dots:nth-child(8) {\r\n  animation-delay: 0s;\r\n}\r\n\r\n.loading-text .dots:nth-child(9) {\r\n  animation-delay: 0.2s;\r\n}\r\n\r\n.loading-text .dots:nth-child(10) {\r\n  animation-delay: 0.4s;\r\n}\r\n\r\n/* RTL Support */\r\n[dir=\"rtl\"] .loading-text {\r\n  direction: rtl;\r\n}\r\n\r\n/* Responsive Design */\r\n@media (max-width: 768px) {\r\n  .loader {\r\n    width: 100px;\r\n    height: 100px;\r\n  }\r\n\r\n  .loader-circle::before {\r\n    width: 12px;\r\n    height: 12px;\r\n  }\r\n\r\n  .loading-text {\r\n    font-size: 20px;\r\n  }\r\n\r\n  .loading-text .phrase {\r\n    font-size: 22px;\r\n  }\r\n\r\n  [dir=\"rtl\"] .loading-text {\r\n    font-size: 22px;\r\n  }\r\n}\r\n\r\n@media (prefers-color-scheme: dark) {\r\n  .loading-text {\r\n    color: #fff;\r\n  }\r\n\r\n  .loading-text .letter {\r\n    color: #fff;\r\n  }\r\n\r\n  .loading-text .phrase {\r\n    color: #fff;\r\n  }\r\n\r\n  @keyframes wave {\r\n    0%, 100% {\r\n      transform: translateY(0);\r\n      color: #fff;\r\n    }\r\n    50% {\r\n      transform: translateY(-10px);\r\n      color: #4285f4;\r\n    }\r\n  }\r\n\r\n  @keyframes pulse {\r\n    0%, 100% {\r\n      opacity: 1;\r\n      transform: scale(1);\r\n      color: #fff;\r\n    }\r\n    50% {\r\n      opacity: 0.7;\r\n      transform: scale(1.05);\r\n      color: #4285f4;\r\n    }\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
